// Update company setting

export const COMPANY_SETTING_UPDATING = `/api/settings/organisation/update/`;

export const COMPANY_SETTING_UPDATING_META = `/api/settings/organisation/update/meta/`;

export const COMPANY_LOGO_UPLOADING = `/api/settings/organisation/logo/upload/`;
